import { z } from "zod";

// Existing schemas (keep these as they are in your current file)
export const providerSchema = z.object({
  provider: z.string().min(1, "Please select an insurance provider"),
});

export const otherInsuranceProviderSchema = z.object({
  otherProvider: z.string().min(1, "Please enter your insurance provider"),
});

export const planTypeProviderSchema = z.object({
  planTypeProvider: z.string().min(1, "Please select a plan type"),
});

export const medicalConditionsSchema = z.object({
  medicalConditions: z
    .array(z.string())
    .min(1, "Please select at least one option"),
});

export const planCoverageSchema = z.object({
  planCoverage: z.string().min(1, "Please select a plan coverage"),
});

export const bcbsPlanSchema = z.object({
  bcbsPlan: z.string().min(1, "Please select a BCBS plan"),
});

export const anthemEmpirePosSchema = z.object({
  anthemEmpirePos: z.string().min(1, "Please select an option"),
});

export const uhcPlanSchema = z.object({
  uhcPlan: z.string().min(1, "Please select a UHC plan"),
});

export const confirmSecondaryInsuranceSchema = z.object({
  hasSecondaryInsurance: z.string().min(1, "Please select an option"),
});

export const aetnaPlanSchema = z.object({
  aetnaPlan: z.string().min(1, "Please select a plan type"),
});

export const fidelisPlanSchema = z.object({
  fidelisPlan: z.string().min(1, "Please select a Fidelis plan"),
});
